module.exports = __webpack_public_path__ + "static/media/13_(c)_stephan_anders.0cbb54e7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/0800/events/13_(c)_stephan_anders.jpg
// module id = 1242
// module chunks = 0